import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { Price } from 'src/app/simulator-booking/models/price';
import { PriceService } from 'src/app/simulator-booking/services/price.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { SimulatorService } from 'src/app/simulator-booking/services/simulator.service';
import { PriceBandService } from 'src/app/simulator-booking/services/price-band.service';
import { forkJoin } from 'rxjs';
import { Simulator } from 'src/app/simulator-booking/models/simulators';
import { PriceBand } from 'src/app/simulator-booking/models/price-band';
import { BookingDurationService } from 'src/app/simulator-booking/services/booking-duration.service';
import { BookingDuration } from 'src/app/simulator-booking/models/booking-duration';

@Component({
    selector: 'price-edit-modal',
    templateUrl: './price-edit-modal.component.html',
    styleUrl: './price-edit-modal.component.scss',
    standalone: false
})
export class PriceEditModalComponent extends BaseModalComponent implements OnInit {
  price: Price;
  simulators: Simulator[] = [];
  priceBands: PriceBand[] = [];
  availableBookingDurations: BookingDuration[] = [];
  isLoading: boolean = false;

  form = new FormGroup({
    id: new FormControl(null, [Validators.required]),
    simulatorId: new FormControl(null, [Validators.required]),
    priceBandId: new FormControl(null, [Validators.required]),
    amount: new FormControl(null, [Validators.required, Validators.min(0)]),
    durationMinutes: new FormControl(30, [Validators.required])
  });

  constructor(
    private priceService: PriceService,
    private simulatorService: SimulatorService,
    private priceBandService: PriceBandService,
    public dialogRef: MatDialogRef<PriceEditModalComponent>,
    private sessionService: SessionService,
    private bookingDurationService: BookingDurationService
  ) {
    super();
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    forkJoin({
      simulators: this.simulatorService.getAllByOrganization(
        { organizationId: this.sessionService.getUser().organizationId }
      ),
      priceBands: this.priceBandService.getAllByOrganization(
        { organizationId: this.sessionService.getUser().organizationId }
      ),
      bookingDurations: this.bookingDurationService.getAllByOrganization(
        { organizationId: this.sessionService.getUser().organizationId }
      )
    }).subscribe({
      next: (result: any) => {
        this.simulators = result.simulators.results;
        this.priceBands = result.priceBands.results;
        this.availableBookingDurations = result.bookingDurations;

        if (this.price) {
          this.form.patchValue({
            id: this.price.id,
            simulatorId: this.price.simulatorId,
            priceBandId: this.price.priceBandId,
            amount: this.price.amount,
            durationMinutes: this.price.durationMinutes
          });
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      }
    });
  }

  submit() {
    if (this.form.valid) {
      this.isLoading = true;
      const data = {
        ...this.form.value,
        organizationId: this.sessionService.getUser().organizationId,
        lastEditedBy: this.sessionService.getUserId()
      };

      this.priceService.update(this.price.id, data).subscribe({
        next: () => {
          this.dialogRef.close('save');
        },
        error: (error) => {
          console.error(error);
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
  }
}
